import { Navigate } from "react-router-dom";
import { PAGE_TITLES } from "@miplatform/constants";
import { homesRoutes } from "./homes/homesRoutes";
import { Communities, CommunityDetails, Profile } from "../views";
import { ProfileDetails } from "../views/Schedule/ProfileDetails/ProfileDetails";

export const routes = [
  // Default route; shows dispatch schedule
  {
    path: "/",
    name: "",
    element: <Navigate to="/homes" replace />,
    handle: { title: PAGE_TITLES.HOMES },
  },
  // Homes
  ...homesRoutes,
  // Communities
  {
    path: "/communities",
    name: "Communities",
    element: <Communities />,
    handle: { title: PAGE_TITLES.COMMUNITIES },
  },
  {
    path: "/communities/:id/:tab?",
    name: "CommunityDetails",
    element: <CommunityDetails />,
    handle: { title: PAGE_TITLES.COMMUNITY },
  },
  // Misc.
  {
    path: "/profile",
    name: "Profile",
    element: <Profile />,
    handle: { title: PAGE_TITLES.PROFILE },
  },
  {
    path: "/profile/:id",
    name: "ProfileDetails",
    element: <ProfileDetails />,
    handle: { title: PAGE_TITLES.PROFILE },
  },
];
